import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomNgxSpinnerService } from 'src/app/services/spinner/custom-ngx-spinner.service';


@Component({
  selector: 'app-ngx-spinner',
  templateUrl: './custom-ngx-spinner.component.html'
})
export class CustomNgxSpinnerComponent {
  constructor(
    private loadingService: CustomNgxSpinnerService, private spinner: NgxSpinnerService) {
      this.loadingService.loading$.subscribe((show)=>{
        if(show){
          this.spinner.show();
        }else{
          this.spinner.hide();
        }
      });
    }
}
